import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { GridCustomToolBarButton, ToolBar, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { ResourcePlanningEntity } from "../resourcePlanning/resourcePlanning.js";
import { EntityServiceReportMaterial } from "../serviceReport/serviceReportMaterialsInGrid.js";
import { ProjectArticleViewModel } from "./projectMaterial.js";
import React from "react";
export interface ProjectMaterialOverviewProps extends AppBaseProps {
    entity: ProjectArticleViewModel;
}

interface ProjectmaterialOverviewViewModel {
    AssigmentOverviews: ResourcePlanningEntity[];
    ServiceReportOverviews: EntityServiceReportMaterial[];
}

export default class ProjectMaterialOverview extends React.Component<ProjectMaterialOverviewProps, {
    data: ProjectmaterialOverviewViewModel;
    selectedItem: ProjectArticleViewModel;
}>{
    private common = new AppHelper();
    private alreadyPlannedMaterialGridRef = null;
    private consumedMaterialGridRef = null;
    private alreadyPlannedMaterialGridOptions = {};
    private consumedMaterialGridOptions = {};

    constructor(props) {
        super(props);
        this.common.init(this);
        this.state = {
            data: null,
            selectedItem: null
        }
    }

    componentDidMount() {
        this.loadData();
    }

    private loadData = async () => {
        let url = "ProjectMaterialOverview/Get?projNr=" + encodeURIComponent(this.props.entity.Projnr) + "&pos=" + encodeURIComponent(this.props.entity.Pos);
        var result = await HTTPService.get<JsonResultClass<ProjectmaterialOverviewViewModel>>(url);
        if (result.Code == 0) {
            this.setState({ data: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    handleCustomButtonClick = async (id: string) => {
        if (id === "all") {
            this.setState({ selectedItem: null });
        }
    }

    private onAssignmentMaterialSelectionChanged = (dataItem: any) => {
        this.setState({ selectedItem: dataItem });
    }

    public renderAlreadyPlannedMaterialGrid = () => {
        if (!Helper.hasValue(this.state.data))
            return null
        return <Grid
            data={this.state.data.AssigmentOverviews}
            options={this.alreadyPlannedMaterialGridOptions}
            id="projectAlreadyPlannedMaterial"
            ref={this.alreadyPlannedMaterialGridRef}
            onSelectionChanged={this.onAssignmentMaterialSelectionChanged}
        />
    }

    public renderConsumedMaterialGrid = () => {
        if (!Helper.hasValue(this.state.data))
            return null

        let gridData = this.state.data.ServiceReportOverviews;
        if (Helper.hasValue(this.state.selectedItem))
            gridData = gridData.filter(x => x.PIndex == this.state.selectedItem.PIndex);

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({ autoEnabledOnRecordSelected: false, caption: Helper.getTranslation("Standard.Alle"), enabled: true, iconClass: "k-i-refresh", id: "all" });
        return <div>
            <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleCustomButtonClick} />
            <Grid
                data={gridData}
                options={this.consumedMaterialGridOptions}
                id="projectConsumedMaterial"
                ref={this.consumedMaterialGridRef}
            />
        </div>
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: () => { } });
        return <CommonApp {...props} titleProps={{ followed: this.props.entity.IsWatched, title: this.props.title }} />;
    }
}